<div class="restricted-content">
  <div class="top section">
    <div class="left">
      <div class="title">{{ featureInfo.featureTitle | translate }}</div>
      <div class="description">{{ featureInfo.description | translate }}</div>
      <ul class="top-points">
        <span *ngFor="let point of featureInfo.topPoints">
          <li><mat-icon>check_circle_outline</mat-icon> {{ point | translate }}</li>
          <br />
        </span>
      </ul>
      <a
        mat-flat-button
        color="primary"
        class="button"
        [attr.data-action]="'restricted-content-upgrade:{{ featureInfo.featureId }}'"
        [routerLink]="['/upgrade-subscription-tier']"
      >
        <ng-container *ngIf="isFreeTier$ | async; else paidTier">
          {{ 'RESTRICTED_FEATURE_CONTENT_V2.UPGRADE' | translate }}
        </ng-container>
        <mat-icon class="button-link">arrow_circle_up</mat-icon>
      </a>
      <ng-template #paidTier>
        {{ 'RESTRICTED_FEATURE_CONTENT_V2.COMPARE' | translate }}
      </ng-template>
      <a
        *ngIf="featureInfo.featureId"
        mat-stroked-button
        color="secondary"
        [attr.data-action]="'restricted-content-learnMore:{{ featureInfo.featureId }}'"
        class="button"
        href="{{ featureInfo.learnMoreLink }}"
        target="_blank"
      >
        {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
        <mat-icon class="button-link">open_in_new</mat-icon>
      </a>
      <div *ngIf="dialogConfig$ | async as dialogConfig; else noSalesperson">
        <p>
          <a (click)="openSalespersonDialog(dialogConfig)">{{
            'RESTRICTED_FEATURE_CONTENT_V2.TALK_TO_SALES' | translate
          }}</a>
          {{ 'RESTRICTED_FEATURE_CONTENT_V2.OR_CALL_US' | translate }}
          <a href="tel:18559555585">1-855-955-5585</a>
        </p>
      </div>
      <ng-template #noSalesperson>
        <p>{{ 'RESTRICTED_FEATURE_CONTENT_V2.CALL_US' | translate }} <a href="tel:18559555585">1-855-955-5585</a></p>
      </ng-template>
    </div>
    <div class="img-container">
      <img class="access-image" src="{{ featuredImage }}" />
    </div>
  </div>
  <div class="more-info section">
    <div class="title">{{ featureInfo.moreInfoTitle | translate }}</div>
    <div class="card-container">
      <mat-card appearance="outlined">
        <mat-card-content class="content">
          <mat-icon>{{ featureInfo.moreInfoSection1Icon }}</mat-icon>
          <span class="card-title">{{ featureInfo.moreInfoSection1Title | translate }}</span>
          <span>{{ featureInfo.moreInfoSection1Description | translate }}</span>
          <a
            *ngIf="featureInfo.moreInfoSection1Link"
            mat-stroked-button
            color="secondary"
            href="{{ featureInfo.moreInfoSection1Link }}"
            target="_blank"
          >
            {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
          </a>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="content">
          <mat-icon>{{ featureInfo.moreInfoSection2Icon }}</mat-icon>
          <span class="card-title">{{ featureInfo.moreInfoSection2Title | translate }}</span>
          <span>{{ featureInfo.moreInfoSection2Description | translate }}</span>
          <a
            *ngIf="featureInfo.moreInfoSection2Link"
            mat-stroked-button
            color="secondary"
            class="card-learn-more"
            href="{{ featureInfo.moreInfoSection2Link }}"
            target="_blank"
          >
            {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
          </a>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div *ngIf="featureInfo.videoLink" class="video"></div>
  <div *ngIf="featureInfo.faqs" class="faq section">
    <div class="title">{{ 'RESTRICTED_FEATURE_CONTENT_V2.FAQ' | translate }}</div>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let faq of featureInfo.faqs">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ faq.question | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="answer" [innerHTML]="faq.answer | translate"></p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
